








































import { Vue, Component } from 'vue-property-decorator'
import {State} from "vuex-class";
import { UserDetailInterface } from '@/models/User';

@Component
export default class ClasesUsuarios extends Vue{
    @State(state => state.auth.user) user: any;
    @State(state => state.user.userDetails) userDetails: UserDetailInterface;

    public category: '';
    public async BindClases(){
        await this.$store.dispatch('bindClases', 'asc')
    }

    public colors: string[] = [
        'blue', 'pink', 'purple', 'indigo', 'teal darken-4', 'orange '
    ];


    get dataClases(){
        if (this.user.category == 'ADULTOS'){
            return this.$store.getters.claseAductos
        }else {
            return this.$store.getters.claseNiños

        }
    }


    created(){

        this.BindClases()

    }
}
